import {Component, OnInit, ViewChild} from '@angular/core';
import {ApiService} from '../../../shared/services/api.service';
import {ContactTemp} from '../../../entities/contact-temp.model';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ColumnMode, DatatableComponent} from '@swimlane/ngx-datatable';
import {ActivatedRoute, Router} from '@angular/router';
import {JhiLanguageService} from 'ng-jhipster';
import {Contact} from '../../../entities';
import {IMyDateModel, IMyDpOptions} from 'mydatepicker';
import {LocalStorageService} from 'ng2-webstorage';
import {BaseDataView} from '../../../entities/base-data-view.model';
import {plainToClass} from 'class-transformer';
import {Principal} from '../../../shared';

@Component({
  selector: 'app-base-data',
  templateUrl: './base-data.component.html',
  styles: []
})
export class BaseDataComponent implements OnInit {

  @ViewChild('companyTable') companyTable: DatatableComponent;
  account;
  rowsCompanies = [];
  sortingCompanies = {prop: 'date', dir: 'asc'};

  loadingIndicator = true;

  contacts: BaseDataView[];
  contactIds = [];
  private modalRef: any = null;
  private selectedContact: BaseDataView;
  contactByUserId: Contact[];

  archive: boolean;

  searchInputMerchant = '';
  tempRows = [];
  rows = [];
  webDataChanges;

  marketMasterFilter: {
    label: string,
    options: {
      value: string,
      displayname: string,
      firstname: string,
      lastname: string,
      number: string,
    }[],
    selected: {
      value: string,
      displayname: string,
      number: string,
    }
  };

  marketDayFilter: {
    label: string,
    options: {
      value: string,
      displayname: string,
      number: string,
    }[],
    selected: {
      value: string,
      displayname: string,
      number: string,
    }
  };

  datePickerOptions: IMyDpOptions = {
    dayLabels: {su: 'So', mo: 'Mon', tu: 'Di', we: 'Mi', th: 'Do', fr: 'Fr', sa: 'Sa'},
    monthLabels: { 1: 'Jan', 2: 'Feb', 3: 'Mrz', 4: 'Apr', 5: 'Mai', 6: 'Jun', 7: 'Jul', 8: 'Aug', 9: 'Sep', 10: 'Okt',
      11: 'Nov', 12: 'Dez' },
    dateFormat: 'dd.mm.yyyy',
    showTodayBtn: true,
    todayBtnTxt: 'Heute',
    firstDayOfWeek: 'mo',
    yearSelector: false,
    monthSelector: false,
    openSelectorOnInputClick: true,
    height: '26px',
    width: '239px'
  };

  datePickerDate: IMyDateModel = null;

  useLastMarketDetail: boolean;
  lastMarketDetail: string;
  lastMarketDetailTitle: string;
  marketdayId: number;
  date: string;

  constructor(
    private apiService: ApiService,
    private modalService: NgbModal,
    private jhiLanguageService: JhiLanguageService,
    public router: Router,
    private route: ActivatedRoute,
    private localStorage: LocalStorageService,
    private principal: Principal,
  ) {
    this.jhiLanguageService.setLocations(['base-data']);
    this.archive = this.router.url === '/base-data-archive';
    this.sortingCompanies = {prop: 'date', dir: (this.archive) ? 'desc' : 'asc'};
    this.principal.identity().then((account) => this.account = account);
  }

  ngOnInit() {
    this.route.queryParams.subscribe(queryParams => {
      this.useLastMarketDetail = (queryParams && queryParams['useLastMarketDetail']) || false;
      this.marketdayId = (queryParams && queryParams['marketdayId']) || null;
      if (queryParams && queryParams['date']) {
        const date = new Date(new Date(queryParams['date']).setHours(0));
        this.datePickerDate = {
          date: {
            year: date.getFullYear(),
            month: date.getMonth() + 1,
            day: date.getDate()
          },
          jsdate: date,
          formatted: this.pad((date.getDate()).toString(), 2)
            + '.' + this.pad((date.getMonth() + 1).toString(), 2)
            + '.' + (date.getFullYear()),
          epoc: date.getTime() / 1000,
        };
      }

      if (this.useLastMarketDetail) {
        this.lastMarketDetail = this.localStorage.retrieve('lastMarketDetail');
        this.lastMarketDetailTitle = this.localStorage.retrieve('lastMarketDetailTitle');
      }
    });

    this.loadAll();

    this.marketMasterFilter = {
      label: 'Filter nach Marktleitung',
      options: [
        {
          value: 'all',
          displayname: 'Alle',
          firstname: '',
          lastname: '',
          number: null
        }
      ],
      selected: {
        value: 'all',
        displayname: 'Alle',
        number: null
      }
    };

    this.marketDayFilter = {
      label: 'Filter nach Markttag',
      options: [
        {
          value: 'all',
          displayname: 'Alle',
          number: null
        }
      ],
      selected: {
        value: 'all',
        displayname: 'Alle',
        number: null
      }
    };
  }

  setDataTableColumnModeToForce() {
    if (this.companyTable) {
      this.companyTable.columnMode = ColumnMode.force;
    } else {
      setTimeout(() => {
        this.setDataTableColumnModeToForce();
      }, 100);
    }
  }

  loadAll() {
    Promise.all([this.loadBaseData(), this.loadWebChanges()])
      .then(() => {
        this.loadingIndicator = false;
        this.webDataChanges.forEach((data) => {
          if (!this.rowsCompanies.some((item) => data.originalContact.id === item.merchantId)) {
            // Make MerchantChanges object compatible to ContactTemp
            data.date = data.updated;
            data.changeItems = ['company'];
            data.merchantId = data.originalContact.id;
            this.rowsCompanies.push(data);
          }
        });
        this.tempRows = [...this.rowsCompanies];
        this.rows = this.rowsCompanies;
        this.webDataChanges.forEach(item => this.rows.push(item));

        setTimeout(() => {
          if (this.marketdayId && this.marketDayFilter.options.some(option => option.value === this.marketdayId.toString())) {
            this.marketDayFilter.selected = this.marketDayFilter.options.find(options => options.value === this.marketdayId.toString());
            this.filterByMarketdayAndMM();
          }
          this.updateSearch(null);
        }, 100);
      });
  }

  loadBaseData() {
    return new Promise((resolve, reject) =>  {
      this.apiService.findRegular<BaseDataView>(BaseDataView, 'backoffice/base-data-changes-by-status/'
        + this.archive.toString()).subscribe(
        entries => {
          // If no entries were found, disable loading indicator & show error message
          if (!entries || !entries.length || entries.length <= 0) {
            resolve();
          }
          entries.forEach((item, index) => {
            if (!item.merchantId) {
              console.warn('Entry without merchant: ', item);
            } else if (!this.contactIds.includes(item.merchantId)) {
              const rowCompany = item;

              const changeTypes = [];
              if (item.salesunitChanges) {
                changeTypes.push('salesunit');
              }
              if (item.contactpersonChanges) {
                changeTypes.push('contact');
              }
              if (item.merchantChanges) {
                changeTypes.push('company');
              }
              rowCompany['changeItems'] = changeTypes;

              const mmDisplayname = item.marketMasterFirstname + ' ' + item.marketMasterLastname;
              rowCompany['updatedByDisplayName'] = mmDisplayname;
              rowCompany['updatedByNumber'] = item.marketMasterNumber;

              if (!this.marketMasterFilter.options.some(option => option.value === mmDisplayname)) {
                this.marketMasterFilter.options.push({
                  value: mmDisplayname,
                  displayname: mmDisplayname,
                  firstname: item.marketMasterFirstname,
                  lastname: item.marketMasterLastname,
                  number: (item.marketMasterNumber) ? item.marketMasterNumber : null
                });
              }

              if (!this.marketDayFilter.options.some(option => option.value === item.marketdayId.toString())) {
                this.marketDayFilter.options.push({
                  value: item.marketdayId.toString(),
                  displayname: item.marketdayKeyword,
                  number: item.marketdayNumber
                });
              }

              rowCompany['date'] = item.lastUpdate;

              this.rowsCompanies.push(rowCompany);
              this.contactIds.push(item.merchantId);
            } else {
              const rowCompanyToChangeIndex = this.rowsCompanies.findIndex(rowCompany =>
                rowCompany.merchantId === item.merchantId);
              const rowCompanyToChange = this.rowsCompanies[rowCompanyToChangeIndex];

              if (rowCompanyToChange['date']) {
                if (item.lastUpdate > rowCompanyToChange['date']) {
                  rowCompanyToChange['date'] = item.lastUpdate;
                }
              } else {
                rowCompanyToChange['date'] = item.lastUpdate;
              }

              this.rowsCompanies[rowCompanyToChangeIndex] = rowCompanyToChange;

              const changeItems = this.rowsCompanies.find(rowCompany =>
                rowCompany.merchantId === item.merchantId)['changeItems'] as Array<string>;

              if (item.salesunitChanges && !changeItems.includes('salesunit')) {
                changeItems.push('salesunit');
              }
              if (item.contactpersonChanges && !changeItems.includes('contact')) {
                changeItems.push('contact');
              }
              if (item.merchantChanges && !changeItems.includes('company')) {
                changeItems.push('company');
              }
            }
            resolve();
          });
          // Sort filter options asc by name
          this.marketMasterFilter.options.sort((a, b) => {
            if (a.value === 'all') { return 1; }
            if (b.value === 'all') { return 1; }
            return a.lastname > b.lastname ? 1 : (a.lastname < b.lastname ? -1 : 0);
          });

          // Sort filter options asc by market number
          this.marketDayFilter.options.sort((a, b) => a.number > b.number ? 1 : (a.number < b.number ? -1 : 0));
        }

      );

    });

  }

  loadWebChanges() {
    return new Promise((resolve, reject) => {
      this.apiService.get('backoffice/merchant-changes/' + this.archive.toString())
        .subscribe((result) => {
          const data: any[] = JSON.parse(result._body);
          this.webDataChanges = plainToClass(ContactTemp, data);

          /*
          * MG-1058: Disable Filter. Everyone with access to base-data changes should see everything.
          if (this.account.contact.branches !== '01 - Geschäftsführung') {
            this.webDataChanges = this.webDataChanges.filter((item) =>
              this.account.contact.branches.split('|').some(a => item.lastRelevantBranches.split(';').some(b => a === b)));
          }
           */
          resolve();
        }, e => {
          console.log('error loading merchant-changes: ', e);
          reject(e);
        });
    });
  }

  openModal(modal: any, contact: BaseDataView) {
    this.modalRef = this.modalService.open(modal);
    this.selectedContact = contact;
  }

  onSelect(event) {
    const targetUrl = (this.archive) ? '/base-data-archive/company' : '/base-data/company';
    this.router.navigate([targetUrl, event.selected[0].merchantId], {queryParamsHandling: 'preserve'}).then();
  }

  updateSearch(event) {
    const searchValMarketTitle = this.searchInputMerchant.toLowerCase();

    this.rows = this.tempRows
      .filter((contact: (Contact | ContactTemp)) => {
        return (
          ((contact.merchantNumber) ? contact.merchantNumber.toLowerCase() : 'n.v.').indexOf(searchValMarketTitle) !== -1
          || ((contact.company) ? contact.company.toLowerCase().indexOf(searchValMarketTitle) !== -1 : false)
          || !searchValMarketTitle);
      })
      .filter((contact: (Contact | ContactTemp)) => {
        return (((this.datePickerDate && this.datePickerDate.jsdate && contact['date'])
          ? new Date(new Date(contact['date']).setHours(0)).toDateString() === this.datePickerDate.jsdate.toDateString()
          : true));
      });
    this.companyTable.offset = 0;
  }

  changeFilter(filter, filterOption) {
    filter.selected = filterOption;
    this.filterByMarketdayAndMM();
  }

  filterByMarketdayAndMM() {
    if (this.marketMasterFilter.selected.value === 'all' && this.marketDayFilter.selected.value === 'all') {
      this.rows = this.rowsCompanies;
    } else if (this.marketMasterFilter.selected.value !== 'all' && this.marketDayFilter.selected.value === 'all') {
      this.rows = this.rowsCompanies.filter(company => company['marketMasterNumber'] === this.marketMasterFilter.selected.number);
    } else if (this.marketMasterFilter.selected.value === 'all' && this.marketDayFilter.selected.value !== 'all') {
      this.rows = this.rowsCompanies.filter(company => company['marketdayId'].toString() === this.marketDayFilter.selected.value);
    } else if (this.marketMasterFilter.selected.value !== 'all' && this.marketDayFilter.selected.value !== 'all') {
      this.rows = this.rowsCompanies.filter(company => company['marketMasterNumber'] === this.marketMasterFilter.selected.number)
      .filter(company => company['marketdayId'].toString() === this.marketDayFilter.selected.value);
    }

    this.tempRows = [...this.rows];
    this.updateSearch(null);
  }

  onDateChanged(event: IMyDateModel) {
    this.datePickerDate = event;
    this.updateSearch(null);
  }

  pad(num, size) {
    let s = num + '';
    while (s.length < size) {
      s = '0' + s;
    }
    return s;
  }

}



// WEBPACK FOOTER //
// ./src/app/base-data/components/base-data/base-data.component.ts